"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackError = trackError;
function reportToDataDog(error, context) {
  // @ts-ignore
  var datadog = window.DD_RUM;
  if (!datadog) {
    return false;
  }
  datadog.addError(error, context);
  return true;
}
function trackError(error) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var didReport = reportToDataDog(error, context);
  if (didReport) {
    return;
  }
  console.error(error, context);
}
//# sourceMappingURL=error.utils.js.map